import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { BasePageComponent } from '../../../base-page.component';
import { Client } from '../../../shared/models/customer.model';
import { MachineModuleService } from '../../../shared/services/machineModule.service';

@Component({
  templateUrl: './customer-detail-page.component.html',
  standalone: false
})
export class CustomerDetailPageComponent extends BasePageComponent implements OnInit {
  customer: Client;

  constructor(private router: Router, location: Location, private route: ActivatedRoute, private customersService: MachineModuleService) {
    super(location);
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const clientNumber = params['clientNumber'];
      this.customersService.getCustomer(clientNumber).subscribe((customer) => {
        this.customer = customer;
      });
    });
  }

  viewMachines() {
    this.router.navigate([`${this.appRoute}/customers/${this.customer.clientNumber}/machines`]);
  }

  viewInspections() {
    this.router.navigate([`${this.appRoute}/customers/${this.customer.clientNumber}/inspections`]);
  }

  editCustomer() {
    this.router.navigate([`${this.appRoute}/customers/${this.customer.clientNumber}/edit`]);
  }

  goToBack() {
    this.router.navigate([this.appRoute, 'customers']);
  }
}
